function throttle(func, wait = 1000) {
    let lastCall = 0;
    let timeout;

    return (...args) => {
        const now = new Date().getTime();
        const timeBetweenCalls = now - lastCall;

        if (!lastCall || timeBetweenCalls >= wait) {
            func.apply(this, args);
            lastCall = now;
        } else {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                lastCall = now;
            }, wait - timeBetweenCalls);
        }
    };
}

export default throttle;
